// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TenantSiteAndPrescriberObjectData } from './tenantSiteAndPrescriberObjectData.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TenantSiteAndPrescriberObject {
    'success': boolean;
    'data': TenantSiteAndPrescriberObjectData | null;
    'messages': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TenantSiteAndPrescriberObject>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "TenantSiteAndPrescriberObjectData"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return TenantSiteAndPrescriberObject.attributeTypeMap;
    }
}
